import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";
import ChatIcon from "@material-ui/icons/Chat";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import NewTicketModal from "../../components/NewTicketModal";
import { tNegocio } from "./shared";

export function useCustomerChat() {
  const history = useHistory();
  const [ticketContact, setTicketContact] = useState(null);
  const [busy, setBusy] = useState(false);

  const openChat = async (customer) => {
    const contactId = customer?.contactId || customer?.id;
    if (!contactId || busy) return;
    setBusy(true);
    try {
      const { data } = await api.get(`/negocio/customers/${contactId}/open-ticket`);
      if (data?.ticket?.uuid) {
        history.push(`/tickets/${data.ticket.uuid}`);
        return;
      }
      setTicketContact({
        id: contactId,
        contactId,
        conversationSource: "customer",
        conversationId: contactId,
        name: customer.name,
        number: customer.number,
        telegram: customer.telegram,
      });
    } catch (e) {
      toastError(e);
    } finally {
      setBusy(false);
    }
  };

  const modal = ticketContact ? (
    <NewTicketModal
      modalOpen
      initialContact={ticketContact}
      onClose={(ticket) => {
        setTicketContact(null);
        if (ticket?.uuid) history.push(`/tickets/${ticket.uuid}`);
      }}
    />
  ) : null;

  return { openChat, busy, modal };
}

export function CustomerChatButton({ customer, color = "#00897b" }) {
  const { openChat, busy, modal } = useCustomerChat();
  return (
    <>
      <Tooltip title={tNegocio("pages.customers.openChat")}>
        <span>
          <IconButton
            size="small"
            disabled={busy}
            onClick={(e) => {
              e.stopPropagation();
              openChat(customer);
            }}
            style={{ color }}
          >
            {busy ? <CircularProgress size={16} /> : <ChatIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
      {modal}
    </>
  );
}
